import { useContext, useState } from 'react';
import { useLingui } from '@lingui/react';
import { Trans, msg } from '@lingui/macro';
import { useForm, Controller } from 'react-hook-form';
import {
  Alert,
  Box,
  Button,
  Container,
  Grid,
  LinearProgress, Link,
  TextField,
  Typography,
  useTheme } from
'@mui/material/';
import { appFlatTextFieldSx } from '../consts/app-flat-text-field-sx';
import Copyright from '../components/Copyright';
import dayjs from 'dayjs';
import useHttp from '../hooks/useHttp';
import { ThemeContext } from '../App';
import { NewApiBaseUrl } from '../consts/new-api-base-url';
import useHttpApiNew from '../hooks/useHttpApiNew';
import { useLocation } from 'react-router-dom';
import { getBrandingUrls } from '../config/market';

const BRAND = getBrandingUrls();
// eslint-disable-next-line no-restricted-globals
const sendEmailUrl = new URL('/api/send_email', location);
const newSendEmailUrl = new URL(`${NewApiBaseUrl}/Mail`);

const to = process.env.REACT_APP_ADMIN_ADDRESS;
const object = 'Password reset request';

export default function ForgotPwd({ isMobile }) {
  const location = useLocation();
  const { control, formState, handleSubmit } = useForm({ mode: 'onChange' });
  const { sendRequest, isLoading, error } = useHttp();
  const { _ } = useLingui();
  const state = location.state;
  const token = state?.token || null;
  const [message, setMessage] = useState('');
  const { mode } = useContext(ThemeContext);
  const { request } = useHttpApiNew();
  const theme = useTheme();
  const fieldSx = appFlatTextFieldSx(theme);

  const onSubmit = async (data) => {
    if (Object.keys(formState.errors).length) return;


    const username = data.username;
    const name = data.name;
    const surname = data.surname;
    const content = `On ${dayjs()} the user ${username || `${name} ${surname}`} requested a password reset. ADaMS.`;



    const responseEmailSender = await request(newSendEmailUrl, 'POST', { content, to, object }, { Authorization: `Bearer ${token}` });
    if (responseEmailSender.responseAnyError) return;
    setMessage('An email has been sent to the administrator. You will be contacted soon.');

    {








      /*
      sendRequest({
       url: sendEmailUrl
       , httpMethod: 'POST'
       , httpBody: { content, to, object }
       , manageResData: () => {
         setMessage('An email has been sent to the administrator. You will be contacted soon.')
       }
      })
       */}};const logoUrl = mode === 'dark' ? BRAND.authLogoDark : BRAND.authLogoLight;return <Container component="main" maxWidth={isMobile ? 'xs' : 'sm'}>
      <Box mt={8} display='flex' flexDirection='column'
      alignItems='center'>
      

        <Box width='50%'>
          <img src={logoUrl} alt='ADaMS logo' width='100%' />
        </Box>
        <Box
        width='100%'
        display='flex'
        flexDirection='column'
        alignItems='center'
        component='form'
        onSubmit={handleSubmit(onSubmit)}
        noValidate
        mt='2rem'>
        
          <Typography textAlign='center' variant='h5'>
            <Trans>
              Please input your username to submit a reset password request to the Administrator.
            </Trans>
          </Typography>
          <Controller
          name='username'
          control={control}
          defaultValue=''
          render={({ field, fieldState }) =>
          <TextField
            margin={isMobile ? 'dense' : 'normal'}
            fullWidth
            label={_(msg`username`)}
            autoComplete='username'
            sx={fieldSx}
            error={!!fieldState.error}
            helperText={fieldState.error ? fieldState.error.message : null}
            {...field} />

          }
          rules={{
            validate: (value, { name, surname }) => value.trim() !== '' || name.trim() !== '' && surname.trim() !== '' || _(msg`Provide username or name AND surname`)
          }}
          // rules={{ required: _(msg`Username is required`) }}
        />
          <Typography mt={2} textAlign='center' variant='h5'>
            <Trans>
              Alternatively, if you don't remember your username, please input your name and surname.
            </Trans>
          </Typography>
          <Controller
          name='name'
          control={control}
          defaultValue=""
          render={({ field, fieldState }) =>
          <TextField
            margin={isMobile ? 'dense' : 'normal'}
            fullWidth
            label={_(msg`Name`)}
            autoComplete='name'
            autoFocus
            sx={fieldSx}
            error={!!fieldState.error}
            helperText={fieldState.error ? fieldState.error.message : null}
            {...field} />

          }
          rules={{
            validate: (value, { username, surname }) => username.trim() !== '' || value.trim() !== '' && surname.trim() !== '' || _(msg`Provide username or name AND surname`)
          }} />
        
          <Controller
          name='surname'
          control={control}
          defaultValue=""
          render={({ field, fieldState }) =>
          <TextField
            margin={isMobile ? 'dense' : 'normal'}
            fullWidth
            label={_(msg`Surname`)}
            autoComplete='surname'
            sx={fieldSx}
            error={!!fieldState.error}
            helperText={fieldState.error ? fieldState.error.message : null}
            {...field} />

          }
          rules={{
            validate: (value, { username, name }) => username.trim() !== '' || value.trim() !== '' && name.trim() !== '' || _(msg`Provide username or name AND surname`)
          }} />
        
          {isLoading &&
        <Box width='100%'>
              <LinearProgress />
            </Box>}
          {message && <Alert sx={{ mt: 2 }} severity='success'>{message}</Alert>}
          {error && <Alert sx={{ mt: 2 }} severity='error'>{error}</Alert>}
          <Button
          type="submit"
          fullWidth={isMobile}
          variant="contained"
          color='primary'
          sx={{
            mt: 3,
            mb: 2,
            width: '100%',
            background: theme.palette.newColors.pinkGradient,
            color: '#fff',
            borderRadius: '12px',
            py: 1.25,
            '&.Mui-disabled': {
              background: '#ccc',
              color: '#666'
            }
          }}>
          
            <Trans>Submit</Trans>
          </Button>
          <Grid container>
            <Grid item xs>
              <Link href="/" variant="body2">
                <Trans>Login</Trans>
              </Link>
            </Grid>
            <Grid item>
              <Link href="/signup" variant="body2">
                <Trans>Sign Up</Trans>
              </Link>
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: { xs: 3, sm: 5 },
        flexWrap: 'wrap',
        mt: 3
      }}>
      
        <img
        src={BRAND.loginFlag}
        alt=""
        style={{ height: 'auto', width: 'auto', maxWidth: 120 }} />
      
        <img
        src={BRAND.loginSeal}
        alt=""
        style={{ height: 'auto', width: 'auto', maxWidth: 100 }} />
      
      </Box>
      <Box mt={4} display='flex' justifyContent='center'>
        <Copyright />
      </Box>
    </Container>;

}